var $ = require("jquery");
var Fancyapps = require("@fancyapps/ui");

module.exports = {
	init: function () {
		this.loadHandlers();
	},
	windowX: 0,
	windowY: 0,
	mapX: 0,
	mapY: 0,
	filterX: 0,
	filterY: 0,
	activateFromSelect: function (target) {
		if (target.value) {
			//Fancyapps.Fancybox.show([{ src: "#dialog-content", type: "inline" }]);
			this.highlightRegionFromCounty(target.value);
		}
	},
	activateFromClick: function (target) {
		let county = $(target).attr("id");
		this.highlightRegionFromCounty(county);
	},
	highlightRegionFromCounty: function (county) {
		$("#ky-map").addClass("active");
		let groupEl = $("#" + county).parent();
		let groupId = groupEl.attr("id");
		groupEl.addClass("highlight");
		$(".map__result").addClass("active");

		// Scroll the location list to the correct element
		let scrollableContainer = $("ul.locations");
		let targetElement = $(".location-" + groupId);
		let firstTargetElement = targetElement.first();

		targetElement.addClass("highlight");
		// Calculate the target scroll position
		let targetScrollTop =
			firstTargetElement.position().top +
			scrollableContainer.scrollTop() -
			15;
		// Animate the scroll
		scrollableContainer.animate(
			{
				scrollTop: targetScrollTop,
			},
			"slow",
		);
	},
	resetMap: function () {
		$("#ky-map").removeClass("active");
		$("#ky-map g").removeClass("highlight");
		$(".map__result").removeClass("active");
		$(".location").removeClass("highlight");
	},
	getDimensions: function () {
		this.windowX = $(window).width();
		this.windowY = $(window).height();
		this.mapX = $(".map.style-2 .map__svg").first().outerWidth();
		this.mapY = $(".map.style-2 .map__svg").first().outerHeight();
		this.filterX = $(".filters").first().outerWidth();
		this.filterY = $(".filters").first().outerHeight();
	},
	setDimensions: function () {
		if (this.windowX > 680) {
			// Map results are side by side with map at this breakpoint
			let locationsY = this.mapY - this.filterY;
			$(".map.style-2 .locations").css("max-height", locationsY);
		} else {
			$(".map.style-2 .locations").css("max-height", 500);
		}
	},
	loadHandlers: function () {
		$(".county-filter-select").on("change", (event) => {
			// Remove any class from previous change
			this.resetMap();
			this.activateFromSelect(event.target);
		});
		$("#ky-map path").on("click", (event) => {
			this.resetMap();
			this.activateFromClick(event.target);
		});
		$(document).on("click", (event) => {
			// If the click was not on map, dropdown or location box, reset map
			if (
				!$(event.target).parents("#ky-map").length > 0 &&
				!$(event.target).parents(".location").length > 0 &&
				!$(event.target).hasClass("county-filter-select")
			) {
				this.resetMap();
			}
		});
		$(window).on("load", (event) => {
			this.getDimensions();
			this.setDimensions();
		});
		$(window).on("resize", (event) => {
			// Your code to execute on window resize goes here
			this.getDimensions();
			this.setDimensions();
		});
	},
};
